export default "__VITE_ASSET__Dda$4EPS__"